import { Status } from '@iqueue/ui-kit'

export default function WellOperationFactor({ factor }) {
  // TODO load options

  return <Status
    progress={ Math.floor(factor * 100) }
    warning={ factor < 0.7 }
    error={ factor < 0.4 }
  />
}
